import React from "react";
import styled from "styled-components";
import ServerComInfo from "../ServerComInfo";
import FillBar from "../../../../components/metrics/FillBar";
import { MarginTopStyled } from "../../../../../style/components/common.styled";
import utilsService from "../../../../../servises/utils.service";

const Styles = styled.div`
    .llddeeassdd {
        //background: #0e1b25;
        background-color: rgb(52,55,65);
        height: 22px;
    }

    .llddeeassdd-s {

    }    
`;

const StylesWrapper = styled.div`
    
`;

const GpusStyles = styled.div`
    height: 190px;
    overflow-y: auto;
    margin: 22px 0;
`;

const generateData = gpuInfo => {
    if (!gpuInfo || gpuInfo.length === 0) {
        return [];
    }

    const firstGpu = gpuInfo[0];
    const data = {
        name: firstGpu.name,
        list: gpuInfo.map(gpu => {
            return {
                util: gpu.gpu_util,
                index: gpu.index,
                mem_total: gpu.mem_total,
                mem_used: gpu.mem_used,
                mem_util: gpu.mem_util,
                temp: gpu.temp
            };
        })
    };
    return data;
};

const ServerGpuWidget = ({ server }) => {
    let isGpuAvailable = false;
    let gpus = null;
    const metric = server?.metrics?.[0];
    if (metric && metric.gpu_info && metric.gpu_info.length > 0) {
        const firstGpu = metric?.gpu_info?.[0]?.is_available;
        if (firstGpu) {
            gpus = metric.gpu_info;
            isGpuAvailable = true;
        }
    }

    const data = generateData(gpus);
    let gpuUtil = "";
    if(isGpuAvailable) {
        data.list.forEach(gpu => {
            gpuUtil += `gpu ${gpu.index}: ${gpu.util}%, `;
        });
    }

    return (
        <Styles>
            { isGpuAvailable && (
                <StylesWrapper>
                    <ServerComInfo
                        name={ "GPU Model" }
                        data={ data.name }
                    />
                    <ServerComInfo
                        name={ "GPU Utilization" }
                        data={ gpuUtil }
                    />
                    <GpusStyles>
                        {data.list.map(gpu => {
                            const memoryTotalCalculated = utilsService.formatBytes(utilsService.mbToBytes(gpu.mem_total));
                            const memoryUsedCalculated = utilsService.formatBytes(utilsService.mbToBytes(gpu.mem_used));
                            const memoryTotalOriginal = utilsService.mbToBytes(gpu.mem_total);
                            const memoryUsageOriginal = utilsService.mbToBytes(gpu.mem_used);

                            const spanStyle = {};
                            if (gpu.temp > 46) {
                                spanStyle.color = "#F8C63D";
                            }
                            if( gpu.temp > 80 ) {
                                spanStyle.color = "#F86B63";
                            }

                            const title = <legend style={{fontSize: 11}} className='color-2'>Memory gpu:{ gpu.index }, util: {gpu.mem_util}%, temperature: <span style={spanStyle}>{ gpu.temp }</span>°C</legend>
                            return (
                                <div key={ gpu.index }>
                                    <MarginTopStyled>
                                        <FillBar
                                            nameOvveride={title}
                                            total={ memoryTotalCalculated.value }
                                            totalUnit={ memoryTotalCalculated.unit }
                                            current={ memoryUsedCalculated.value }
                                            currentUnit={ memoryUsedCalculated.unit }
                                            originalTotal={ memoryTotalOriginal }
                                            originalCurrent={ memoryUsageOriginal }
                                        />
                                    </MarginTopStyled>
                                </div>
                            );
                        })}
                    </GpusStyles>
                </StylesWrapper>
            ) }
            { !isGpuAvailable && (
                <div style={ { textAlign: "center" } }>No GPU available</div>
            ) }
        </Styles>
    );
};

export default ServerGpuWidget;
